import { TOOLS_EN, PILLARS_EN, PRODUCT_DISCLAIMER_EN } from "./tools.en";

export const TOOLS = [
  {
    slug: "onix-messenger",
    num: "01",
    name: "ONIX MESSENGER",
    pillar: "COMUNICAR",
    title: "Conversaciones privadas, bajo tus reglas.",
    short:
      "Un espacio de comunicación propio para tu organización: lo que se dice, quién lo dice y cómo se coordina queda dentro, protegido y bajo tu control.",
    description:
      "ONIX Messenger da a tu organización un espacio de comunicación propio y protegido. Cada persona accede con una identidad verificada, las conversaciones y los archivos viajan cifrados, y tú decides quién entra, desde qué dispositivos y hasta cuándo. Si algo cambia —una baja, un dispositivo perdido, un proyecto que termina— puedes suspender o revocar el acceso al momento.",
    capabilities: [
      "Identidad criptográfica",
      "Cifrado extremo a extremo sujeto a versión y auditoría",
      "Grupos y archivos",
      "Gobierno de dispositivos",
      "Minimización de metadatos",
      "Despliegues dedicados cuando el riesgo lo requiera",
    ],
    limit:
      "Somos claros: el cifrado no puede proteger un terminal ya comprometido, ni evitar que un participante haga una captura, ni recuperar información que ya salió. Las propiedades criptográficas concretas se verifican en cada versión.",
  },
  {
    slug: "onix-vision",
    num: "02",
    name: "ONIX VISION",
    pillar: "OBSERVAR",
    title: "Tus cámaras ven mucho. ONIX Vision te ayuda a entenderlo.",
    short:
      "Convierte las cámaras y sesiones autorizadas de tu organización en eventos comprensibles, investigaciones ordenadas y evidencia que se sostiene.",
    description:
      "ONIX Vision transforma horas de vídeo en información con la que se puede trabajar: detecta eventos, los prioriza por riesgo y los presenta en una línea temporal clara. Cuando algo requiere investigación, cada hallazgo queda documentado con su origen, su fecha y su cadena de custodia, para que la evidencia se sostenga cuando más importa.",
    capabilities: [
      "Eventos y riesgo",
      "Cámaras y timeline",
      "Investigaciones y casos",
      "Sesiones seguras",
      "Evidence Vault",
      "Integridad, retención y cadena de custodia",
      "Reglas, zonas y umbrales",
    ],
    limit:
      "La detección automática señala y prioriza; las conclusiones las ponen las personas. La precisión y la idoneidad del sistema deben validarse en cada escenario real antes de apoyar decisiones en él.",
  },
  {
    slug: "onix-tactical-graph",
    num: "03",
    name: "ONIX TACTICAL GRAPH",
    pillar: "INVESTIGAR",
    title: "Ver las conexiones que una lista nunca te enseñará.",
    short:
      "Un entorno visual donde personas, organizaciones, lugares e indicadores se conectan sobre grafos y mapas, para que tu equipo investigue con contexto.",
    description:
      "ONIX Tactical Graph ayuda a tu equipo a pensar visualmente: conecta personas, organizaciones, activos, incidentes y ubicaciones procedentes de fuentes autorizadas, y los sitúa en grafos y mapas donde las relaciones y los tiempos se entienden de un vistazo. Las hipótesis, las notas y las evidencias quedan ordenadas dentro de cada caso, listas para compartirse con control.",
    capabilities: [
      "Entidades y vínculos",
      "Mapas y capas",
      "Temporalidad",
      "Niveles de confianza",
      "Fuentes autorizadas",
      "Hipótesis, notas, evidencias, tareas y exportaciones controladas",
    ],
    limit:
      "Que dos elementos aparezcan conectados no demuestra causalidad ni identidad. Cada dato conserva su procedencia, su fecha, su base legítima y su nivel de confianza, y así debe interpretarse.",
  },
  {
    slug: "onix-malware-static-analyzer",
    num: "04",
    name: "ONIX MALWARE STATIC ANALYZER",
    pillar: "ANALIZAR",
    title: "Entender un archivo sospechoso sin tener que ejecutarlo.",
    short:
      "Inspección estática y preferentemente offline: hashes, estructura, indicadores y señales de riesgo de una muestra, sin ejecutarla deliberadamente.",
    description:
      "Cuando llega un archivo sospechoso, la primera pregunta es qué es y qué contiene. ONIX Malware Static Analyzer lo examina sin ejecutarlo deliberadamente: identifica su tipo real, extrae hashes, cadenas, dominios y rutas, mide entropía y recoge los hallazgos en un informe técnico listo para integrarse con tus casos o tu SIEM.",
    capabilities: [
      "Identificación de tipo real",
      "Firmas y entropía",
      "Extracción controlada",
      "Cadenas, dominios y rutas",
      "Mitigación de archive bombs y traversal",
      "Informe técnico",
      "Integración con casos y SIEM",
    ],
    limit:
      "El análisis estático cuenta lo que el archivo es, no todo lo que haría al ejecutarse. No sustituye un sandbox autorizado, la ingeniería inversa ni el análisis forense cuando el caso lo requiere.",
  },
  {
    slug: "onix-autosoc-siem",
    num: "05",
    name: "ONIX AUTOSOC / SIEM",
    pillar: "PROTEGER",
    title: "Menos ruido, mejores decisiones para tu equipo de seguridad.",
    short:
      "Centraliza la telemetría de tu organización, separa lo urgente de lo irrelevante y coordina la respuesta con un registro completo de cada paso.",
    description:
      "ONIX AutoSOC reúne las señales de tus sistemas en un solo lugar, las correlaciona y las prioriza para que tu equipo dedique su tiempo a lo que de verdad importa. Los casos se gestionan con playbooks, la automatización trabaja siempre bajo supervisión humana y cada acción queda registrada para auditoría y reporting ejecutivo.",
    capabilities: [
      "Ingesta de eventos",
      "Reglas y comportamiento",
      "Correlación temporal",
      "Triage y enriquecimiento",
      "Casos y playbooks",
      "Reporting ejecutivo",
      "Automatización asistida bajo supervisión",
    ],
    limit:
      "La cobertura real depende de qué fuentes se conectan, del alcance acordado y de las pruebas de aceptación. Preferimos definir eso contigo antes que prometer visibilidad total.",
  },
  {
    slug: "sensorizacion-ciberdefensa",
    num: "06",
    name: "SENSORIZACIÓN Y CIBERDEFENSA ONIX",
    pillar: "PROTEGER",
    title: "Saber qué tienes, cómo está y por dónde te pueden entrar.",
    short:
      "Inventario de activos, telemetría, control de accesos y refuerzo de redes, dispositivos, servicios y nube: visibilidad primero, protección después.",
    description:
      "No se puede proteger lo que no se ve. Esta capacidad ayuda a tu organización a inventariar sus activos, medir su exposición y reforzar lo que lo necesite: segmentación, acceso remoto seguro, protección perimetral, WAF, VPN, hardening, copias y revisiones periódicas. Desde la evaluación inicial hasta el servicio gestionado del día a día.",
    capabilities: [
      "Superficie externa",
      "Inventario y estado",
      "Telemetría",
      "Segmentación",
      "Acceso remoto",
      "Protección perimetral",
      "Deception controlada",
      "WAF, VPN, hardening, copias y revisiones periódicas",
    ],
    limit:
      "Alinearse con ENS, ISO 27001 u otros marcos exige alcance formal, implantación, evidencias y auditoría. No declaramos certificaciones que no estén acreditadas.",
  },
  {
    slug: "dwi-onix",
    num: "07",
    name: "DWI ONIX",
    pillar: "INVESTIGAR",
    title: "Lo que circula sobre tu organización, convertido en inteligencia.",
    short:
      "Recopila y conecta fuentes autorizadas —incluida la dark web permitida— y conviértelas en indicadores, alertas e investigaciones trazables.",
    description:
      "DWI ONIX vigila lo que aparece sobre tu organización en corpus autorizados: URLs, servicios Onion permitidos, documentos, chats, feeds y datos que tú aportes. Extrae dominios, correos, credenciales expuestas, CVEs y relaciones; detecta typosquatting; y convierte cada coincidencia en una alerta o un caso con su fuente, fecha, hash y nivel de confianza. Siempre con validación humana.",
    capabilities: [
      "Extracción de dominios, correos, IPs, CVEs, hashes, archivos, cuentas y relaciones",
      "Trackers",
      "Conjuntos y reglas",
      "Typosquatting",
      "Validación humana",
      "Hipótesis y casos",
      "Evidencia con fuente, fecha, hash, confianza y limitaciones",
      "Assessment, monitoring, instancia dedicada e intelligence service",
    ],
    limit:
      "Buscamos en el corpus recopilado, importado o conectado: nadie puede prometer acceso universal a toda la dark web, atribuciones infalibles ni eliminación de contenido. Cada búsqueda exige finalidad, autorización y fuentes permitidas.",
  },
];

export const PILLARS = [
  { num: "01", name: "COMUNICAR", desc: "Que tu equipo hable, comparta y se coordine sin exponer nada." },
  { num: "02", name: "OBSERVAR", desc: "Ver lo que ocurre en vídeo, red, endpoints, servicios y dominios." },
  { num: "03", name: "ANALIZAR", desc: "Dar sentido a eventos, malware, relaciones y comportamiento." },
  { num: "04", name: "PROTEGER", desc: "Detectar, controlar accesos, segmentar y responder a tiempo." },
  { num: "05", name: "INVESTIGAR", desc: "Ordenar casos, grafos, cronologías, indicadores y notas." },
  { num: "06", name: "EVIDENCIAR", desc: "Preservar la integridad, la custodia y la auditoría de cada hallazgo." },
  { num: "07", name: "DIRIGIR", desc: "Decidir con dashboards, alertas, informes y tareas claras." },
];

export const PRODUCT_DISCLAIMER =
  "Disponibilidad, alcance, controles y propiedades finales sujetos a contrato, versión, integración y pruebas de aceptación.";

export const getTools = (lang) => (lang === "en" ? TOOLS_EN : TOOLS);
export const getPillars = (lang) => (lang === "en" ? PILLARS_EN : PILLARS);
export const getProductDisclaimer = (lang) => (lang === "en" ? PRODUCT_DISCLAIMER_EN : PRODUCT_DISCLAIMER);
export const getTool = (slug, lang = "es") => getTools(lang).find((t) => t.slug === slug);
